export default "__VITE_ASSET__17I8L0t0lhAgMuEFUP2bCA__"